import(/* webpackMode: "eager" */ "/codebuild/output/src2921135241/src/apps/junonkuji/src/app/error.tsx");
